module.exports = __webpack_public_path__ + "img/pattern1.9a0bee6.svg";